import { Icon, Text } from '@kanda-libs/ks-design-library';

const Content: React.FunctionComponent = function () {
  return (
    <div className="flex flex-col flex-1 -mt-20">
      <div className="flex flex-col max-w-120 m-auto">
        <Icon icon="check-circle-color" size={92} className="mx-auto mb-8" />
        <Text
          text="Thank you for providing consent"
          className="text-20-24-em text-center mb-6"
        />
        <Text
          text="You don't need to take any further action for now, Kanda will handle things from here. If any more action is requitred from you, we will reach out to you directly"
          className="text-14-22 text-center"
        />
      </div>
    </div>
  );
};

export default Content;
